module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9c0dda925ff4840f5ddfe6c27f1a2755.png";